import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const base = `${API}/api/patient-portal`;
const opts = { withCredentials: true };

export const patientPortalApi = {
  home: () => axios.get(`${base}/home`, opts).then((r) => r.data),
  capabilities: () => axios.get(`${base}/capabilities`, opts).then((r) => r.data),
  appointments: () => axios.get(`${base}/appointments`, opts).then((r) => r.data),
  family: () => axios.get(`${base}/family`, opts).then((r) => r.data),
  careHistory: (patientId) =>
    axios
      .get(`${base}/care-history`, { ...opts, params: patientId ? { patient_id: patientId } : {} })
      .then((r) => r.data),
  visitDetail: (id) => axios.get(`${base}/visits/${id}`, opts).then((r) => r.data),
  book: (payload) => axios.post(`${base}/book`, payload, opts).then((r) => r.data),
};
